import React, { memo } from 'react'
import { CircularProgress } from '@mui/material'
import tw from 'twin.macro'

const FullScreenLoaderComponent = () => {
  return (
    <div css={tw`flex items-center justify-center h-full w-full`}>
      <CircularProgress size={60} />
    </div>
  )
}

export const FullScreenLoader = memo(FullScreenLoaderComponent)
